import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingAM from "../assets/rigve_loader.gif";

export const ProfessionalCollections = () => {
  const navigate = useNavigate();
  const { id, name } = useParams();
  const [mainCategories, setMainCategories] = useState([]);
  const [selectedMainCatId, setSelectedMainCatId] = useState(null);
  const [collections, setCollections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMainCategories = async () => {
      try {
        const response = await fetch(
          "https://webadmin.rigve.com/api/get_main_category",
        );
        const data = await response.json();
        setMainCategories(data.data || []);
        setSelectedMainCatId(data.data[0]?.id || null);
      } catch (err) {
        setError(err.message);
      }
    };
    fetchMainCategories();
  }, []);

  useEffect(() => {
    if (!selectedMainCatId) return;

    const fetchCategories = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `https://webadmin.rigve.com/api/get_category?main_cat_id=${id}`,
        );
        const data = await response.json();
        setCollections(data.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCategories();
  }, [selectedMainCatId, id]);

  if (isLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <img src={LoadingAM} className="w-16 h-16" alt="Loading" />
      </div>
    );

  if (error)
    return <div className="p-10 text-center text-red-500">{error}</div>;

  return (
    <main className="bg-white text-slate-900">
      <section
        id="products"
        className="container mx-auto max-w-7xl px-4 py-8 overflow-hidden"
      >
        {/* PRODUCT GRID */}
        <div className="mb-8">
          <h2 className="fs-21 font-bold">Browse {name} Products</h2>

          <p className="text-slate-500 mt-2">
            Explore premium wall texture collections designed for style and
            performance.
          </p>
        </div>

        <div
          id="Collections"
          className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-6"
        >
          {collections.map((collection) => (
            <article
              key={collection.id}
              onClick={() => navigate(`/collections/${collection.id}/${id}`)}
              className="group cursor-pointer rounded-2xl overflow-hidden border shadow-sm hover:shadow-xl transition bg-white"
            >
              <div className="relative overflow-hidden">
                <img
                  src={collection.image}
                  alt={collection.name}
                  className="h-48 md:h-60 w-full object-cover group-hover:scale-110 transition duration-500"
                  loading="lazy"
                />

                {/* <span className="absolute top-4 left-4 bg-white/90 px-3 py-1 rounded-full text-xs font-bold">
                  Top Pick
                </span> */}
              </div>

              <div className="p-5">
                <h3 className="text-md font-bold line-clamp-1">
                  {collection.name}
                </h3>

                <p className="text-slate-500 mt-2 line-clamp-2">
                  {collection.description ||
                    "Elegant and reliable professional-grade product collection."}
                </p>

                <div className="mt-4 text-orange-600 font-semibold">
                  View Details →
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center bg-gradient-to-r from-orange-500 to-orange-600 rounded-2xl p-10 md:p-16 text-white">
          <h3 className="text-2xl font-bold">Ready to Transform Your Walls?</h3>

          <p className="mt-4 text-lg text-orange-100 max-w-2xl mx-auto">
            Explore premium wall textures and create interiors that impress.
          </p>

          <button
            data-modal-target="select-modal"
            data-modal-toggle="select-modal"
            className="mt-8 px-8 py-4 bg-white text-orange-600 font-bold rounded-full hover:scale-105 transition"
            type="button"
            onClick={() => (window.location.href = "/BookFreeSiteVisit")}
          >
            Book Free Site Visit
          </button>
        </div>
      </section>
    </main>
  );
};
